import * as React from 'react';
import { MuiThemeProvider } from '@material-ui/core/styles';
import memoize from 'lodash/memoize';
import { createTheme } from '../styles/theme';
export var getTheme = memoize(function (direction, paletteType, zIndex) {
    return createTheme({
        direction: direction,
        palette: {
            type: paletteType,
        },
        zIndex: zIndex !== null && zIndex !== void 0 ? zIndex : {},
    });
}, function (direction, paletteType, zIndex) { return "".concat(direction, "|").concat(paletteType, "|").concat(JSON.stringify(zIndex)); });
export var BbThemeProvider = function (props) {
    var theme = props.theme, isRtl = props.isRtl, children = props.children, zIndex = props.zIndex;
    var bbTheme = React.useMemo(function () { return getTheme(isRtl ? 'rtl' : 'ltr', theme === 'dark' ? 'dark' : 'light', zIndex); }, [isRtl, theme, zIndex]);
    return React.createElement(MuiThemeProvider, { theme: bbTheme }, children);
};
//# sourceMappingURL=BbThemeProvider.js.map